import React, { useState } from 'react';

// Painel Recebimentos / Pagamentos (estilo Nibo) — Dashboard do Financeiro (31/10/2026).
// Dados de GET /financeiro/painel-contas. Totais vêm do backend (todos os registros);
// listas limitadas a `limite` por aba → "Ver todos (N)".

const fmt = v => 'R$ ' + parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
const fmtData = d => { if (!d) return '—'; const p = String(d).split('T')[0].split('-'); return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : '—'; };
const FONT = "'DM Sans',system-ui,sans-serif";
const MONO = "'DM Mono',monospace";

const ABAS = [
  { k: 'proximos', label: 'Próximos' },
  { k: 'mes_atual', label: 'Mês atual' },
  { k: 'vencido', label: 'Vencido' },
];
const MESES = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
// 'AAAA-MM' ± n meses
const somaMes = (mes, n) => { const [a, m] = mes.split('-').map(Number); const d = new Date(Date.UTC(a, m - 1 + n, 1)); return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`; };
const rotuloMes = mes => { const [a, m] = mes.split('-'); return `${MESES[Number(m) - 1]}/${a}`; };
const ddmm = iso => { const p = String(iso || '').split('-'); return p.length === 3 ? `${p[2]}/${p[1]}` : ''; };
const seta = { background: 'none', border: 'none', cursor: 'pointer', padding: '0 1px', fontSize: '12px', flexShrink: 0, lineHeight: 1, color: '#6B7A8D', fontFamily: "'DM Sans',system-ui,sans-serif" };

function Bloco({ titulo, cor, corFundo, dados, periodo, carregando, somenteLeitura, onBaixar, onAbrir, onVerTodos, onMudarMes, rotuloBaixar }) {
  const [aba, setAba] = useState('proximos');
  const lista = dados.listas[aba] || [];
  const tot = dados.totais[aba] || { total: 0, qtd: 0 };
  const emAberto = dados.totais.em_aberto || { total: 0, qtd: 0 };

  return (
    <div style={{ background: '#fff', borderRadius: '12px', border: '0.5px solid rgba(26,58,92,0.12)', overflow: 'hidden', display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      <div style={{ padding: '14px 16px 0', borderTop: `3px solid ${cor}` }}>
        <div style={{ fontSize: '14px', fontWeight: '700', color: cor, marginBottom: '10px' }}>{titulo}</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.3fr 1fr', borderBottom: '1px solid rgba(26,58,92,0.1)' }}>
          {ABAS.map(a => {
            const t = dados.totais[a.k] || { total: 0, qtd: 0 };
            const ativa = aba === a.k;
            const corValor = a.k === 'vencido' ? '#C0392B' : (ativa ? cor : '#1C2533');
            return (
              <div key={a.k} role="button" tabIndex={0} onClick={() => setAba(a.k)} onKeyDown={e => { if (e.key === 'Enter') setAba(a.k); }}
                style={{ background: ativa ? corFundo : 'none', borderBottom: ativa ? `2px solid ${cor}` : '2px solid transparent', marginBottom: '-1px', padding: '8px 4px', cursor: 'pointer', textAlign: 'left', fontFamily: FONT, minWidth: 0 }}>
                {a.k === 'mes_atual' && periodo ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1px', fontSize: '11px', color: '#6B7A8D', fontWeight: '600', textTransform: 'uppercase', whiteSpace: 'nowrap', letterSpacing: '-0.2px' }}>
                    <button title="Mês anterior" disabled={carregando} onClick={e => { e.stopPropagation(); setAba('mes_atual'); onMudarMes(somaMes(periodo.mes, -1)); }} style={seta}>←</button>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{periodo.vigente ? a.label : rotuloMes(periodo.mes)}</span>
                    <button title="Próximo mês" disabled={carregando} onClick={e => { e.stopPropagation(); setAba('mes_atual'); onMudarMes(somaMes(periodo.mes, 1)); }} style={seta}>→</button>
                  </div>
                ) : (
                  <div style={{ fontSize: '11px', color: a.k === 'vencido' ? '#C0392B' : '#6B7A8D', fontWeight: '600', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{a.label}</div>
                )}
                {a.k === 'mes_atual' && periodo && (
                  <div style={{ fontSize: '10px', color: '#9AA3AE', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {periodo.vigente ? `a vencer até ${ddmm(periodo.ate)}` : `${ddmm(periodo.de)} a ${ddmm(periodo.ate)}`}
                  </div>
                )}
                <div style={{ fontSize: '14px', fontWeight: '700', fontFamily: MONO, color: corValor, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', opacity: carregando && a.k === 'mes_atual' ? 0.4 : 1 }}>{fmt(t.total)}</div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ maxHeight: '340px', overflowY: 'auto', flex: 1 }}>
        {lista.length === 0 && <div style={{ color: '#9AA3AE', fontSize: '13px', padding: '24px 16px', textAlign: 'center' }}>Nenhum lançamento</div>}
        {lista.map(l => {
          const mostrarDesc = l.descricao && l.descricao !== l.nome;
          return (
            <div key={l.id} onClick={() => !somenteLeitura && onAbrir(l)}
              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 16px', borderBottom: '0.5px solid rgba(26,58,92,0.08)', cursor: somenteLeitura ? 'default' : 'pointer' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#F7F9FC'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
              <div style={{ fontFamily: MONO, fontSize: '12px', color: l.vencido ? '#C0392B' : '#6B7A8D', fontWeight: l.vencido ? '700' : '400', width: '76px', flexShrink: 0 }}>{fmtData(l.vencimento)}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '13px', fontWeight: '600', color: '#1C2533', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.nome}</div>
                {mostrarDesc && <div style={{ fontSize: '12px', color: '#1E5FA5', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{l.descricao}</div>}
              </div>
              <div style={{ fontFamily: MONO, fontSize: '13px', fontWeight: '700', color: cor, whiteSpace: 'nowrap' }}>{fmt(l.valor)}</div>
              {!somenteLeitura && (
                <button onClick={e => { e.stopPropagation(); onBaixar(l); }}
                  style={{ padding: '4px 10px', background: corFundo, border: 'none', color: cor, borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: '700', fontFamily: FONT, whiteSpace: 'nowrap' }}>
                  {rotuloBaixar}
                </button>
              )}
            </div>
          );
        })}
      </div>

      <div style={{ padding: '10px 16px', borderTop: '0.5px solid rgba(26,58,92,0.1)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: '11px', color: '#9AA3AE' }}>{lista.length < tot.qtd ? `Mostrando ${lista.length} de ${tot.qtd}` : `${tot.qtd} lançamento(s)`}</span>
        <button onClick={() => onVerTodos(aba)}
          style={{ background: 'none', border: 'none', color: '#1A6DFF', cursor: 'pointer', fontSize: '12px', fontWeight: '600', fontFamily: FONT }}>
          Ver todos ({tot.qtd})
        </button>
      </div>
      <div style={{ padding: '0 16px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '11px', color: '#9AA3AE' }}>Total em aberto (todos os períodos): <b style={{ fontFamily: MONO, color: '#6B7A8D', whiteSpace: 'nowrap' }}>{fmt(emAberto.total)}</b></span>
        <button onClick={() => onVerTodos('em_aberto')}
          style={{ background: 'none', border: 'none', color: '#1A6DFF', cursor: 'pointer', fontSize: '11px', fontFamily: FONT, whiteSpace: 'nowrap', padding: 0 }}>
          Ver todos
        </button>
      </div>
    </div>
  );
}

export default function PainelContas({ dados, carregando, somenteLeitura, onBaixar, onAbrir, onVerTodos, onMudarMes }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(320px,1fr))', gap: '14px', marginBottom: '14px' }}>
      <Bloco titulo='Recebimentos' cor='#2D7D4F' corFundo='#EAF5EE' dados={dados.entrada} periodo={dados.periodo} carregando={carregando} onMudarMes={onMudarMes} rotuloBaixar='Baixar'
        somenteLeitura={somenteLeitura} onBaixar={onBaixar} onAbrir={onAbrir} onVerTodos={aba => onVerTodos('receita', aba)} />
      <Bloco titulo='Pagamentos' cor='#C0392B' corFundo='#FDECEA' dados={dados.saida} periodo={dados.periodo} carregando={carregando} onMudarMes={onMudarMes} rotuloBaixar='Baixar'
        somenteLeitura={somenteLeitura} onBaixar={onBaixar} onAbrir={onAbrir} onVerTodos={aba => onVerTodos('despesa', aba)} />
    </div>
  );
}
